module.exports = __webpack_public_path__ + "media/application/images/icons/linkedin-56449214acbd8086da177bd983b9859a.svg";